import { Component } from '@angular/core';
import { AuthService } from 'src/app/Service/auth.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent  {
  userData: any;
  constructor(public auth: AuthService) {
    this.auth.userProfileSubject$.subscribe((resp) => {
      this.userData = resp;
    });
  }

 
}
